export default {
    computed: {
        isMobile () {
            return this.width_ <= 900
        },
    },
    data () {
        return {
            width_: null,
        }
    },
    mounted () {
        window.addEventListener('resize', this.handleResize_)
        this.handleResize_()
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.handleResize_)
    },
    methods: {
        handleResize_ () {
            this.width_ = window.innerWidth
        },
    }
}